export const camelToFlat = (camel: string) => {
  if (!camel) {
    return '';
  }
  const camelCase = camel.replace(/([a-z])([A-Z])/g, '$1 $2');
  return (camelCase) ? camelCase : camel;
};
